const getParams = (queryString: string): string => {
  const teardrop = "src=teardrop";
  const firstTimeClient = "firsttimeclient=true";

  const queryIncludesTeardrop = queryString.toLowerCase().includes(teardrop);
  const queryIncludesFirstTimeClient = queryString
    .toLowerCase()
    .includes(firstTimeClient);

  if (
    (!queryIncludesTeardrop && !queryIncludesFirstTimeClient) ||
    !queryString
  ) {
    return "";
  }

  let query = "?";
  if (queryIncludesTeardrop) query += teardrop;
  if (queryIncludesTeardrop && queryIncludesFirstTimeClient) query += "&";
  if (queryIncludesFirstTimeClient) query += firstTimeClient;
  return query;
};

export default getParams;
